'use client';

import '@ui5/webcomponents/dist/MenuItem.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * `MenuItem` is the item to use inside a `Menu`. An arbitrary hierarchy structure can be represented by recursively nesting menu items.
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Menu)
 */
const MenuItem = withWebComponent('ui5-menu-item', ['accessibleName', 'additionalText', 'busyDelay', 'icon', 'text'], ['busy', 'disabled', 'startsSection'], [], []);
MenuItem.displayName = 'MenuItem';
MenuItem.defaultProps = {
  busyDelay: 1000
};
export { MenuItem };